export const HEAD_OF_SUPPORT = "Head of Support";
export const INKLE_CEO = "Inkle CEO";
export const INKLE_CTO = "Inkle CTO";
export const ACCOUNT_MANAGER = "Account Manager";
export const BOOKKEEPER = "Bookkeeper";
export const PREPARER = "Preparer";
export const REVIEWER = "Reviewer";
